import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { changeCompanyModal, requestAddPaymentMethod, resetAddPaymentMethod, resetCompanyReceipts, resetDeletePaymentMethod, resetUpdatePaymentMethod, retrieveCompanyPaymentMethods } from '../../../../../redux/actions/company'
import { Dropdown } from 'react-bootstrap'
import DropdownMenu from '../../../../universal/dropdown-menu'
import AllMethodsTable from './table'
import EmptyTable from '../../../../universal/empty-table'
import { UpperRow } from '../../../../library/upper-row'
import { TableLoader } from '../../../../library/table-loader'
import { sendErrorNotification, sendSuccessNotification } from '../../../../universal/notifications/notifications'

const Index = () => {

    const dispatch = useDispatch()

    const paymentMethods = useSelector(state => state.company.paymentMethods)
    const loading = useSelector(state => state.company.fetchPaymentMethods.loading)

    const deleteMethodStatus = useSelector(state => state.company.deletePaymentMethod.status)
    const deleteMethodError = useSelector(state => state.company.deletePaymentMethod.error)

    const addStatus = useSelector(state => state.company.addPaymentMethod.status)
    const updateStatus = useSelector(state => state.company.updatePaymentMethod.status)

    const selectedCompany = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)
    const companyDetailsLoading = useSelector(state => state.company.fetchDetails.loading)

    const [paymentMethodDropdownOpen, setPaymentMethodDropdownOpen] = useState(false)

    useEffect(() => {
      if(deleteMethodStatus){
        dispatch(retrieveCompanyPaymentMethods({companyId: selectedCompany}))
        dispatch(resetDeletePaymentMethod())
        sendSuccessNotification("Betalingsmetoden ble slettet.")
      }
    }, [deleteMethodStatus])

    useEffect(() => {
      if(deleteMethodError){
        dispatch(resetDeletePaymentMethod())
        sendErrorNotification("Kunne ikke slette betalingsmetode.")
      }
    }, [deleteMethodError])

    useEffect(() => {
      if(addStatus){
        sendSuccessNotification("Betalingsmetode ble lagt til.")
        dispatch(retrieveCompanyPaymentMethods({companyId: selectedCompany}))
        dispatch(resetAddPaymentMethod())
      }
    }, [addStatus])

    useEffect(() => {
      if(updateStatus){
        sendSuccessNotification("Betalingsmetode ble oppdatert.")
        dispatch(retrieveCompanyPaymentMethods({companyId: selectedCompany}))
        dispatch(resetUpdatePaymentMethod())
      }
    }, [updateStatus])

    const retrieveResponseIcon = id => {
      if(false){
        return <i className="fas fa-circle-notch loading fa-spin"></i>
      }
    }

    const clickAddMethod = () => {
      dispatch(changeCompanyModal({addPaymentMethod: true}))
    }

    const renderActionToggle = () => {
        return(
            <Dropdown.Toggle onClick={() => setPaymentMethodDropdownOpen(!paymentMethodDropdownOpen)} disabled={false} id="dropdown-filter">
              {retrieveResponseIcon()} {true ? "Ny betalingsmetode":"Laster inn.."} <i class="fad arrow fa-angle-down"></i>
            </Dropdown.Toggle>
        )
    }

    const selectActionOptions = [
        {
          title: "Nytt kort",
          key: "answeryes",
          active: false,
          action: () => clickAddMethod()
        },
      ]

    const renderMainButtons = () => {
      if(!companyDetailsLoading && !loading){
        return [
          <DropdownMenu content="regular" type="title" color="green" size="regular" toggle={renderActionToggle()} title="Ny betalingsmetode" options={selectActionOptions} open={paymentMethodDropdownOpen} setOpen={setPaymentMethodDropdownOpen}/>
        ]
      }
      return null
    }

    const renderEmptyView = () => {
      if(!loading && !companyDetailsLoading && !paymentMethods.default || !loading && paymentMethods.cards?.length === 0){
        return <EmptyTable title="Ingen betalingsmetoder" description="Her var det veldig tomt, men slapp helt av! Du kan enkelt legge til et kort ved å trykke på knappen øverst til høyre."/>
      }
      return null
    }
    
    return(
       <div className="dashboard-company-payment-history-container">
           <div className="inner-dashboard-company-payment-history-container">
            <UpperRow title="Betalingsmetoder" buttons={renderMainButtons()}/>
            <AllMethodsTable/>
            {renderEmptyView()}
            {loading || companyDetailsLoading ? <TableLoader/>:null}
           </div>
       </div>
    )
}

export default Index